import React from "react";

function Wizard({ step, steps }) {
  if(step >= steps.length) return null;
  return steps[step];
}

export default Wizard;
